import { Plugins } from '@leverege/plugin';
import { ModelFactory } from '@leverege/ui-plugin';
import Util from "./Util.js";
export const FormatterFactory = Plugins.createFactory('AttributeFormatter', {
  pluginKey: 'formatter',
  strategy: Plugins.ALL
});

/** 
 * @param {object} value the value to format
 * @param {object} options the format options
 * @param {object} options.type the type the formatter is applicable too
 * @param {object} options.unit the target unit type
 * @param {object} options.maxDecimals the maximun number of decimals
 * @param {object} options.fixed if true, pad the decimals with zero
 * @return {array} an array format objects (Strings or components). By default, 
 * an aray of value.toString() is returned if no formatter exists for the options
 */
function format(value, options) {
  const formatter = options == null ? null : FormatterFactory.get(options.type);
  if (formatter) {
    return Array.isArray(value) ? value.map(val => formatter.format(val, options)) : formatter.format(value, options);
  }
  return value == null ? [] : Array.isArray(value) ? value : [value.toString()];
}
function createFormatterModel(type) {
  const ftype = Util.getFormatterTypeForType(type);
  const model = ModelFactory.get(ftype);
  if (model) {
    return model.create();
  }
  return null;
}
export default {
  format,
  getFormatterTypeForType: Util.getFormatterTypeForType,
  createFormatterModel
};